// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import SideBarButtonTemplate from '@front/templates/SideBarButtonTemplate.html';
import { ControlsTypes } from '../../UtilsClasses/FactoryConstants';
import { TerceraButton } from '../TerceraButton';
export class TerceraSideBarButton extends TerceraButton {
    constructor() {
        super();
    }
    oncomplete() {
        super.oncomplete();
        this.localize();
    }
    getType() {
        return ControlsTypes.TerceraSideBarButton;
    }
    localize() {
        if (!isNullOrUndefined(this.tooltipKey)) {
            void this.set('tooltip', Resources.getResource(this.tooltipKey));
        }
    }
}
TerceraButton.extendWith(TerceraSideBarButton, {
    template: SideBarButtonTemplate,
    data: function () {
        return {};
    }
});
